import Vue from 'vue'
const $http = Vue.prototype.$http
// 查询设备白名单列表
function getDataList(params) {
  return $http({
    url: $http.adornUrl('/api/app/whiteDevice'),
    method: 'get',
    params: $http.adornParams(params)
  })
}
// 新增设备白名单
function addEquipment(data) {
  return $http({
    url: $http.adornUrl('/api/app/insertWhiteDevice'),
    method: 'post',
    data: $http.adornData(data)
  })
}
// 编辑设备白名单
function editEquipment(data) {
  return $http({
    url: $http.adornUrl('/api/app/updateWhiteDevice'),
    method: 'post',
    data: $http.adornData(data)
  })
}
// 删除设备白名单
function delEquipment(data) {
  return $http({
    url: $http.adornUrl('/api/app/deleteWhiteDevice'),
    method: 'delete',
    data: $http.adornData(data)
  })
}
// 查询同一个产品中的设备白名单
function getList(params) {
  return $http({
    url: $http.adornUrl('/xxx/xxx/xxxx'),
    method: 'get',
    params: $http.adornParams(params)
  })
}
const httpMethods = { addEquipment, editEquipment, delEquipment, getDataList, getList }
export default httpMethods
